import { isB2bDomain } from 'helpers/isDomainLocale';
import { useDomainConfig } from 'hooks/useDomainConfig';
import twMerge from 'utils/twMerge';

type ProductCatnumProps = {
    catalogNumber: string;
    className?: string;
};

export const ProductCatnum: FC<ProductCatnumProps> = ({ catalogNumber, className }) => {
    const domainConfig = useDomainConfig();

    if (!isB2bDomain(domainConfig)) {
        return null;
    }

    return (
        <div className={twMerge('mb-2 mt-1 text-small font-normal text-grayVeryDark', className)}>{catalogNumber}</div>
    );
};
